import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { DateRangePicker, DateRangePickerWrapper } from 'react-dates';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Select from 'react-select';

import {
  setInsightsCriteriaDateRange,
  setInsightsCriteriaOrganisation,
  setInsightsCriteriaSubcategory,
  setInsightsCriteriaType,
  clearInsightsCriteriaBoundaries,
  clearInsightsCriteriaPois,
} from '../store/actions/criteria-actions';

import { setSelectedReportById } from '../store/actions/report-actions';
import { setLastInsightPage } from '../store/actions/route-actions';

import {
  fetchInsightsSummary,
  fetchInsightsFootfall,
  fetchDailyAverages,
  fetchInsightsPoiCount,
  fetchInsightsFootfallOverTime,
  fetchInsightsFootfallPercentage,
  fetchInsightsRepeatVsUnique,
  setFootFallOverTimeUnit,
  selectFootfallTimePeriod,
  downloadAudience,
} from '../store/actions/insights-actions';

import {
  validateReportCriteria,
  insertTitle,
  insertSubTile,

  chooseDownloadableBtn,
  checkDefaultTab,
} from '../utilities/report-helpers';

import Header from './Header';
import Sidebar from './Sidebar';
import InsightsNavBar from './InsightsNavBar';
import SVGIcon from '../components/SVGIcon';
import LoadingContainer from '../components/LoadingContainer';
import FootfallOverTimeGraph from '../components/FootfallOverTimeGraph';
import TravelPastByTheHourGraph from '../components/TravelPastByTheHourGraph';
import CopyrightAndVersion from '../components/CopyrightAndVersion';
import CriteriaModalWrapper from '../components/CriteriaModalWrapper';
import SelectionNotAvailable from '../components/SelectionNotAvailable';
import BarGraph from '../components/BarGraph';
import DownloadPdf from '../components/DownloadPdf';
import DownloadCSVButton from '../components/DownloadCSVButton';

import {
  formatNumber,
  isEmptyObject,
  isDataAvailable,
} from '../utilities/helpers';


import FootfallByPercentage from '../components/FootfallByPercentage';
import FootfallRepeatVsUnique from '../components/FootfallRepeatVsUnique';

const mapStateToProps = (
  { insights, insightsCriteria, client, reports, locations, auth },
  ownProps
) => ({
  ...insights,
  ...insightsCriteria,
  client,
  report: reports.reportDictionary[ownProps.reportId],
  ...locations,
  ableToDownloadCSV: chooseDownloadableBtn(
    'footfall',
    auth.tokenPayload.scopes,
    insightsCriteria.insightType
  ),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setInsightsCriteriaDateRange,
      fetchInsightsSummary,
      fetchInsightsPoiCount,
      fetchInsightsFootfall,
      fetchDailyAverages,
      fetchInsightsFootfallOverTime,
      fetchInsightsFootfallPercentage,
      fetchInsightsRepeatVsUnique,
      setFootFallOverTimeUnit,
      downloadAudience,
      setInsightsCriteriaOrganisation,
      selectFootfallTimePeriod,
      setInsightsCriteriaSubcategory,
      setInsightsCriteriaType,
      setSelectedReportById,
      clearInsightsCriteriaBoundaries,
      clearInsightsCriteriaPois,
      setLastInsightPage
    },
    dispatch
  );

class FootfallInsights extends React.Component {
  state = {
    sinceDate: moment(this.props.sinceDate),
    untilDate: moment(this.props.untilDate),
    focusedInput: null,
    sideBarOpen: true,
    showCriteriaModal: false,
    showSelectionWarning: false,
    selectionWarningText: '',
    currentTimePeriod: this.props.selectedPeriod,
    timePeriodArray: [],
  };

  componentDidMount() {
    this.props.setLastInsightPage('/footfall-insights');
    this.props.clearInsightsCriteriaPois();

    const selectedTab = checkDefaultTab(
      'footfall',
      this.props.insightType,
      this.props.categoriesAvailable,
      this.props.organisationsAvailable
    );

    this.props.setInsightsCriteriaType(selectedTab);
    this.props.setSelectedReportById(this.props.reportId);
    this.props.client.accountType === 'intelligence' &&
      this.populateDatePeriodDropDown();
    // validate before getdata
    const validateResult = this.handelValidateReportCriteria(selectedTab);
    validateResult.showSelectionWarning === false && this.loadData('');
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.criteriaId !== this.props.criteriaId) {
      // validate before getdata
      const selectedTab = checkDefaultTab(
        'footfall',
        this.props.insightType,
        this.props.categoriesAvailable,
        this.props.organisationsAvailable
      );
      this.handelValidateReportCriteria(selectedTab);
    }

    if (
      prevState.showSelectionWarning === true &&
      this.state.showSelectionWarning === false
    ) {
      this.loadData('');
    }
  };

  setFootFallOverTimeUnit = unit => {
    this.props.setFootFallOverTimeUnit(unit);
    setTimeout(this.props.fetchInsightsFootfallOverTime, 100);
  };

  handelValidateReportCriteria = selectedTab => {
    const reportCriteriaValid = validateReportCriteria({
      insightType: selectedTab,
      report: this.props.report,
      subcategory: this.props.subcategory,
      organisation: this.props.organisation,
    });

    this.setState(() => ({
      ...reportCriteriaValid,
    }));
    return reportCriteriaValid;
  };

  handleSetDateRange = ({ startDate: sinceDate, endDate: untilDate }) => {
    if (sinceDate && untilDate) {
      this.props.setInsightsCriteriaDateRange(
        sinceDate.startOf('day').format(),
        untilDate.endOf('day').format()
      );
      this.setState({
        sinceDate: sinceDate.startOf('day'),
        untilDate: untilDate.endOf('day'),
      });
      this.loadData();
    }
  };

  loadData = () => {
    this.props.fetchInsightsSummary();
    this.props.fetchInsightsPoiCount();
    this.props.fetchInsightsFootfall();
    this.props.fetchDailyAverages();
    this.props.fetchInsightsFootfallPercentage();
    this.props.fetchInsightsRepeatVsUnique();
    this.props.fetchInsightsFootfallOverTime();
  };

  isOutsideRangeHandler = selectedDate => {
    if (this.props.client.id === '5dc26da29b7b531cafa425f9') {
      return (
        !selectedDate.isSameOrBefore(moment('20191004', 'YYYYMMDD')) ||
        !selectedDate.isSameOrAfter(moment(this.props.client.firstEventTS))
      );
    }
      return (
        !selectedDate.isSameOrBefore(moment()) ||
        !selectedDate.isSameOrAfter(moment(this.props.client.firstEventTS))
      );

  };

  toggleSideBar = () =>
    this.setState(prevState => ({ sideBarOpen: !prevState.sideBarOpen }));

  openCriteriaModal = () => this.setState(() => ({ showCriteriaModal: true }));
  closeCriteriaModal = () =>
    this.setState(() => ({ showCriteriaModal: false }));
  handleTimePeriod = e => {
    this.setState({ currentTimePeriod: e });
    this.props.selectFootfallTimePeriod(e);
    this.loadData();
  };

  summaryCardRender = () => {
    const firstSummary =
      this.props.client.accountType === 'collects' ? (
        <div className="content-card">
          <span className="FootfallInsights_main_top_cards_info">
            {this.props.insightsSummaryData.eventsCount &&
              formatNumber(this.props.insightsSummaryData.eventsCount)}
          </span>
          location records
        </div>
      ) : (
        <div className="content-card">
          <span className="FootfallInsights_main_top_cards_info">
            {this.renderFirstSummaryCard()}
          </span>
          are the panel
        </div>
      );

    const secondSummary =
      this.props.client.accountType === 'collects' ? (
        <div className="content-card">
          <span className="FootfallInsights_main_top_cards_info">
            {this.props.insightsSummaryData.devicesCount &&
              formatNumber(this.props.insightsSummaryData.devicesCount)}
          </span>
          unique devices
        </div>
      ) : (
        <div className="content-card">
          <span className="FootfallInsights_main_top_cards_info">95%</span>
          confidence level
        </div>
      );

    return (
      <div className="FootfallInsights_main_top_cards">
        {firstSummary}
        {secondSummary}

        <div className="content-card">
          <span className="FootfallInsights_main_top_cards_info">
            {this.props.insightsPoiCountData.poisCount &&
              formatNumber(this.props.insightsPoiCountData.poisCount)}
          </span>
          {this.props.insightsPoiCountData.poisCount &&
          this.props.insightsPoiCountData.poisCount > 1
            ? `points of interest`
            : `point of interest `}
        </div>
      </div>
    );
  };

  renderFirstSummaryCard = () => {
    const { adm0, adm2, adm3, adm4, poiId, boundariesDictionary } = this.props;
    const foundIndex = [adm0, adm2, adm3, adm4, poiId].findIndex(element => element !== null);

    const selectedBoundary = adm0 || adm2 || adm3 || adm4 || poiId;

    if (selectedBoundary === null || selectedBoundary === undefined) {
      // none boundary be choosed

      return boundariesDictionary.country &&
        boundariesDictionary.country.areas
        ? `${boundariesDictionary.country.areas[0].name} devices`
        : `Country devices ${<br />}`;
    } else if (Array.isArray(selectedBoundary) && selectedBoundary.length > 1) {
      // multiple boundary be choosed

      return `Devices from Mutilple Districts / Major Cities`;
    }
      // only one boundary be choosed

      if(selectedBoundary[0].label === "All Regional" || selectedBoundary[0].label === "All Metro" ) return `${selectedBoundary[0].label} devices`

      return foundIndex === 1 || foundIndex === 2
        ? `${selectedBoundary[0].label.substring(
            0,
            selectedBoundary[0].label.indexOf(',')
          )} devices`
        : `${selectedBoundary[0].label.substring(
            selectedBoundary[0].label.indexOf(',') + 1
          )} devices`;

  };

  dailyAveragesPreProcess() {
    if (!isEmptyObject(this.props.insightsDailyAveragesData)) {
      const dataObj = this.props.insightsDailyAveragesData.percent;
      return Object.keys(dataObj).map((key) => ({ name: key, sharePerCent: dataObj[key] }));
    }
  }

  checkCategoryShareDataIsPointless = () => {
    // if the Category Share are all 100 or 0 means pointless data

    let pointLessData = true;

    if (this.props.insightsFootfallPercentageData.length == 0) {
      return true;
    }
      this.props.insightsFootfallPercentageData.forEach((item, idx) => {
        if (item.percentage !== 0 && item.percentage !== 100) {
          pointLessData = false;
        }
      });
      return pointLessData;

  };

  populateDatePeriodDropDown = () => {
    // Ticket issue #392
    let datePeriod = this.props.report.props.datePeriod.concat();
    // filter enable === false
    datePeriod = datePeriod.filter(o => o.enable === true);

    const excuteDefaultSelection = targetObj => {
      this.setState(() => ({
        currentTimePeriod: targetObj,
      }));
      this.props.selectFootfallTimePeriod(targetObj);
    };

    if (datePeriod !== undefined && datePeriod.length > 0) {
      this.setState(() => ({ timePeriodArray: datePeriod }));
      const has90DaysObj = datePeriod.find(o => o.value === 90);
      has90DaysObj === undefined
        ? excuteDefaultSelection(datePeriod[0])
        : excuteDefaultSelection(has90DaysObj);
    }
  };

  renderCalendarInfo = () => {

    const handleClick = datePeriod => {
      this.props.setInsightsCriteriaDateRange(
        moment().subtract(datePeriod, 'days').startOf('day').format(),
        moment().subtract(1, 'days').startOf('day').format(),
      );

      this.setState({
        focusedInput: false,
        sinceDate: moment().subtract(datePeriod, 'days').startOf('day').format(),
        untilDate: moment().subtract(1, 'days').startOf('day').format(),
      });

      this.loadData('');
    };

    return (
      <div>
        <button
          className="quickSelectDatePeriod"
          onClick={() => handleClick(30)}
        >
          {' '}
          Last 30 days
        </button>
        <button
          className="quickSelectDatePeriod"
          onClick={() => handleClick(90)}
        >
          {' '}
          Last 90 days
        </button>
        <button
          className="quickSelectDatePeriod"
          onClick={() => handleClick(365)}
        >
          {' '}
          Last 12 months
        </button>
      </div>
    );
  };

  render() {
    return (
      <div className="FootfallInsights" data-html2canvas-ignore="true">
        <Header />
        {this.state.sideBarOpen && (
          <Sidebar
            loadData={this.loadData}
            toggleSideBar={this.toggleSideBar}
            reportId={this.props.reportId}
          />
        )}
        <main
          className={`FootfallInsights_main${
            this.state.sideBarOpen ? '' : ' FootfallInsights_main_full-width'
          }`}
        >
          {!this.state.sideBarOpen && (
            <button
              className="FootfallInsights_main_open-side-bar-button"
              onClick={this.toggleSideBar}
              openCriteriaModal={this.openCriteriaModal}
            >
              <SVGIcon icon="back-arrow" />
            </button>
          )}
          <div className="FootfallInsights_main_top">
            <div className="container">
              <div className="FootfallInsights_title-bar">
                <div className="FootfallInsights_title-bar_left">
                  <h1>
                    {insertTitle(this.props, this.state.showSelectionWarning)}
                  </h1>
                  <h3>
                    {insertSubTile(this.props, this.state.showSelectionWarning)}
                  </h3>
                </div>
                <div className="FootfallInsights_date-range-group">
                  {this.props.client.accountType === 'collects' ? (
                    <DateRangePicker
                      displayFormat="DD MMM YYYY"
                      startDate={moment(this.state.sinceDate)} // momentPropTypes.momentObj or null,
                      startDateId="your_unique_start_date_id-8294793847289" // PropTypes.string.isRequired,
                      endDate={moment(this.state.untilDate)} // momentPropTypes.momentObj or null,
                      endDateId="your_unique_end_date_id-8294793847289" // PropTypes.string.isRequired,
                      onDatesChange={this.handleSetDateRange} // PropTypes.func.isRequired,
                      focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                      onFocusChange={focusedInput =>
                        this.setState({ focusedInput })
                      } // PropTypes.func.isRequired,
                      isOutsideRange={this.isOutsideRangeHandler}
                      minimumNights={0}
                      calendarInfoPosition="bottom"
                      renderCalendarInfo={this.renderCalendarInfo}
                    />
                  ) : (
                    <Select
                      inputId="category"
                      className="FootfallInsights_time-period-selection"
                      placeholder="Type to search"
                      isDisabled={false}
                      isLoading={false}
                      isRtl={false}
                      isSearchable
                      name="category"
                      options={this.state.timePeriodArray}
                      onChange={this.handleTimePeriod}
                      value={this.state.currentTimePeriod}
                    />
                  )}

                  {(Array.isArray(this.props.ableToDownloadCSV) &&
                  this.props.ableToDownloadCSV.length > 0 &&
                  this.props.client.props.enableAudienceBuilder !== true ) && (
                    <DownloadCSVButton
                      downloadAudience={this.props.downloadAudience}
                      downloadingCSV={this.props.downloadingCSV}
                      label="Download audience .csv"
                      reportType='footfall'
                      insightType={this.props.insightType}
                      ableToDownloadCSV={this.props.ableToDownloadCSV}
                    />
                  )}


                </div>
              </div>
              <div>
                {!this.state.showSelectionWarning && (
                  <LoadingContainer
                    loading={
                      !(
                        this.props.insightsSummaryLoaded === true &&
                        this.props.insightsPoiCountLoaded === true
                      )
                    }
                  >
                    {this.summaryCardRender()}
                  </LoadingContainer>
                )}
              </div>
            </div>
          </div>
          <div className="FootfallInsights_reports container">
            <InsightsNavBar selectedReport={this.props.reportId} />
            {this.state.showSelectionWarning ? (
              <SelectionNotAvailable
                text={this.state.selectionWarningText}
                buttonText={this.state.selectionWarningButtonText}
                openCriteriaModal={this.openCriteriaModal}
                wholePage
              />
            ) : (
              <div className="FootfallInsights_reports_tab-panel">
                <div className="FootfallInsights_reports_grid">
                  {this.props.insightType === 'category' ? (
                    <LoadingContainer
                      loading={!this.props.insightsFootfallLoaded}
                      className="FootfallInsights_reports_grid_top content-card"
                    >
                      <BarGraph
                        data={
                          this.props.insightsFootfallData
                            ? this.props.insightsFootfallData
                            : []
                        }
                        title="Footfall by organisation"
                        barOnScreen={10}
                        buttonOpen
                        isDataAvailable={isDataAvailable(
                          this.props.insightsFootfallData
                        )}
                      />
                    </LoadingContainer>
                  ) : (
                    <LoadingContainer
                      loading={!this.props.insightsFootfallPercentageLoaded}
                      className="FootfallInsights_reports_grid_top content-card"
                    >
                      {isDataAvailable(
                        this.props.insightsFootfallPercentageData
                      ) ? (
                        <FootfallByPercentage
                          data={this.props.insightsFootfallPercentageData}
                          footfallName={`${insertTitle(this.props)}`}
                          isPointlessData={this.checkCategoryShareDataIsPointless()}
                        />
                      ) : (
                        <SelectionNotAvailable
                          text="Graph Currently Unavailable"
                          buttonText=""
                        />
                      )}
                    </LoadingContainer>
                  )}

                  <LoadingContainer
                    loading={!this.props.insightsDailyAveragesLoaded}
                    className="FootfallInsights_reports_grid_left content-card"
                  >
                    <BarGraph
                      data={
                        this.props.insightsDailyAveragesData
                          ? this.dailyAveragesPreProcess()
                          : []
                      }
                      isDataAvailable={isDataAvailable(
                        this.props.insightsDailyAveragesData
                      )}
                      title="Daily averages"
                      barOnScreen={7}
                    />
                  </LoadingContainer>
                  <LoadingContainer
                    loading={!this.props.insightsFootfallRepeatLoaded}
                    className="FootfallInsights_reports_grid_right content-card"
                  >
                    <h3 className="content-card_title">Repeat Vs Unique</h3>
                    {isDataAvailable(this.props.insightsFootfallRepeatData) ? (
                      <FootfallRepeatVsUnique
                        repeatPercent={
                          this.props.insightsFootfallRepeatData.repeatPercent
                        }
                        uniquePercent={
                          this.props.insightsFootfallRepeatData.uniquePercent
                        }
                        averageEventsByPOI={
                          this.props.insightsFootfallRepeatData
                            .averageEventsByOrganisation
                        }
                        insightType={this.props.insightType}
                        organisationLabel={
                          this.props.organisation
                            ? this.props.organisation.label
                            : ''
                        }
                        subcategoryLabel={
                          this.props.subcategory
                            ? this.props.subcategory.label
                            : ''
                        }
                        accountType={this.props.client.accountType}
                        clientId={this.props.client.id}
                      />
                    ) : (
                      <SelectionNotAvailable
                        text="Graph Currently Unavailable"
                        buttonText=""
                      />
                    )}
                  </LoadingContainer>
                  {this.props.client.accountType === 'collects' ? (
                    <LoadingContainer
                      loading={!this.props.insightsFootfallOverTimeLoaded}
                      className="FootfallInsights_reports_grid_bottom content-card"
                    >
                      {isDataAvailable(
                        this.props.insightsFootfallOverTimeData
                      ) ? (
                        <FootfallOverTimeGraph
                          data={this.props.insightsFootfallOverTimeData}
                          unit={this.props.footFallOverTimeUnit}
                          setUnit={this.setFootFallOverTimeUnit}
                          footfallName={`${insertTitle(this.props)} footfall`}
                        />
                      ) : (
                        <SelectionNotAvailable
                          text="Graph Currently Unavailable"
                          buttonText=""
                        />
                      )}
                    </LoadingContainer>
                  ) : (
                    <LoadingContainer
                      loading={!this.props.insightsFootfallOverTimeLoaded}
                      className="FootfallInsights_reports_grid_bottom content-card"
                    >
                      <TravelPastByTheHourGraph
                        data={this.props.insightsFootfallOverTimeData}
                        title="Footfall by the hour"
                      />
                    </LoadingContainer>
                  )}
                </div>
              </div>
            )}
          </div>
          <div className="FootfallInsights_DownlaodPdf">
            <DownloadPdf
              reportType="Footfall"
              isDisabled={
                !(
                  this.props.insightsFootfallOverTimeLoaded &&
                  this.props.insightsDailyAveragesLoaded &&
                  this.props.insightsFootfallLoaded &&
                  this.props.insightsSummaryLoaded &&
                  !this.state.showSelectionWarning
                )
              }
            />
            <CopyrightAndVersion />
          </div>
        </main>
        <CriteriaModalWrapper
          isOpen={this.state.showCriteriaModal}
          close={this.closeCriteriaModal}
          reportId={this.props.reportId}
        />
      </div>
    );
  }
}

FootfallInsights.propTypes = {
  client: PropTypes.object.isRequired, // eslint-disable-line
  report: PropTypes.object.isRequired, // eslint-disable-line
  insightsSummaryData: PropTypes.object.isRequired, // eslint-disable-line
  organisation: PropTypes.object, // eslint-disable-line
  subcategory: PropTypes.object, // eslint-disable-line
  insightsFootfallData: PropTypes.arrayOf(PropTypes.object).isRequired,
  sinceDate: PropTypes.string.isRequired,
  untilDate: PropTypes.string.isRequired,
  insightType: PropTypes.string,
  setInsightsCriteriaDateRange: PropTypes.func.isRequired,
  fetchInsightsSummary: PropTypes.func.isRequired,
  insightsSummaryLoaded: PropTypes.bool.isRequired,
  fetchInsightsFootfall: PropTypes.func.isRequired,
  fetchDailyAverages: PropTypes.func.isRequired,
  insightsFootfallLoaded: PropTypes.bool.isRequired,
  insightsDailyAveragesLoaded: PropTypes.bool.isRequired,
  insightsDailyAveragesData: PropTypes.shape({
    Fri: PropTypes.number,
    Mon: PropTypes.number,
    Sat: PropTypes.number,
    Sun: PropTypes.number,
    Thu: PropTypes.number,
    Tue: PropTypes.number,
    Wed: PropTypes.number,
  }),
  insightsFootfallOverTimeLoaded: PropTypes.bool.isRequired,
  insightsFootfallOverTimeData: PropTypes.arrayOf(PropTypes.object),
  insightsFootfallOverTimeDataUnit: PropTypes.string.isRequired,
  downloadAudience: PropTypes.func.isRequired,
  downloadingCSV: PropTypes.bool.isRequired,
  setFootFallOverTimeUnit: PropTypes.func.isRequired,
  fetchInsightsFootfallOverTime: PropTypes.func.isRequired,
  setInsightsCriteriaOrganisation: PropTypes.func.isRequired,
  setInsightsCriteriaSubcategory: PropTypes.func.isRequired,
  setInsightsCriteriaType: PropTypes.func.isRequired,
  setSelectedReportById: PropTypes.func.isRequired,
  reportId: PropTypes.string.isRequired,
  criteriaId: PropTypes.string.isRequired,
  clearInsightsCriteriaBoundaries: PropTypes.func.isRequired,
};

FootfallInsights.defaultProps = {
  organisation: null,
  subcategory: null,
  insightType: null,
  insightsDailyAveragesData: undefined,
  insightsFootfallOverTimeData: undefined,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FootfallInsights);
